import { predefineSchema, type FromSchemaProperty } from '@witkac/jschema';

const def = predefineSchema<any, any>();

export const addressSchema = def({
  type: 'object',
  properties: {
    KodPocztowy: {
      title: 'Kod pocztowy',
      type: 'string',
      format: 'kod',
      fieldRequired: true,
      validationMessages: {
        format: 'Podaj poprawny kod pocztowy',
      },
    },

    Poczta: {
      title: 'Poczta',
      type: 'string',
      fieldRequired: true,
    },

    Miejscowosc: {
      title: 'Miejscowość',
      type: 'string',
      fieldRequired: true,
    },

    Ulica: {
      title: 'Ulica',
      type: 'string',
      fieldRequired: true,
    },

    Nr: {
      title: 'Numer posesji',
      type: 'string',
      fieldRequired: true,
    },

    NumerLokalu: {
      title: 'Numer lokalu',
      type: 'string',
    },

    Wojewodztwo: {
      title: 'Województwo',
      type: 'string',
      fieldRequired: true,
    },

    Powiat: {
      title: 'Powiat',
      type: 'string',
      fieldRequired: true,
      readOnly() {
        return !this.Wojewodztwo;
      },
    },

    Gmina: {
      title: 'Gmina',
      type: 'string',
      fieldRequired: true,
      readOnly() {
        return !this.Powiat;
      },
    },
  },
});

export type AddressSchema = FromSchemaProperty<typeof addressSchema>;
